(() => {
  const initialize = (scope = document) => {
    const review = document.querySelector('[data-to-review-mode]');
    if (review) {
      scope.querySelectorAll('form.to-newsform').forEach(form => {
        if (form.dataset.reviewBound) return;
        form.dataset.reviewBound = 'true';
        form.addEventListener('submit', event => {
          event.preventDefault();
          event.stopImmediatePropagation();
          if (!form.reportValidity()) return;
          let result = form.querySelector('[data-review-result]');
          if (!result) {
            result = document.createElement('div');
            result.className = 'to-form-status';
            result.dataset.reviewResult = '';
            result.setAttribute('role', 'status');
            result.tabIndex = -1;
            form.append(result);
          }
          result.textContent = form.classList.contains('to-newsform') ? review.dataset.newsletterDone : review.dataset.done;
          try { sessionStorage.removeItem('to-form-' + form.id); } catch (_) {}
          form.reset();
          result.focus();
          result.scrollIntoView({block: 'center', behavior: 'smooth'});
        }, true);
      });
    }
    scope.querySelectorAll('[data-to-form-ready]').forEach(fields => { fields.disabled = false; });
    const cards = [...scope.querySelectorAll('[data-event-state]')];
    scope.querySelectorAll('[data-event-filter]').forEach(button => {
      if (button.dataset.bound) return;
      button.dataset.bound = 'true';
      button.addEventListener('click', () => {
        scope.querySelectorAll('[data-event-filter]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
        cards.forEach(card => { card.hidden = button.dataset.eventFilter !== 'all' && card.dataset.eventState !== button.dataset.eventFilter; });
        const empty = scope.querySelector('[data-events-empty]');
        if (empty) empty.hidden = cards.some(card => !card.hidden);
      });
    });
    const form = scope.querySelector('[data-event-preview]');
    if (form && !form.dataset.bound) {
      form.dataset.bound = 'true';
      const fields = form.querySelector('fieldset');
      const result = form.querySelector('[data-preview-result]');
      const total = form.querySelector('[data-event-total]');
      const update = () => {
        const waitlist = form.elements.scenario.value === 'waitlist';
        total.textContent = waitlist ? '—' : 'Rp ' + (Number(form.elements.quantity.value) * 50000).toLocaleString('id-ID');
        form.querySelector('[data-event-submit]').textContent = (waitlist ? form.dataset.waitlistLabel : form.dataset.registerLabel) + ' ↗';
      };
      try {
        const draft = JSON.parse(sessionStorage.getItem('to-event-preview') || '{}');
        ['name','email','notes','scenario','quantity'].forEach(key => { if (typeof draft[key] === 'string') form.elements[key].value = draft[key]; });
      } catch (_) {}
      form.addEventListener('input', () => {
        update();
        const draft = {};
        ['name','email','notes','scenario','quantity'].forEach(key => { draft[key] = form.elements[key].value; });
        try { sessionStorage.setItem('to-event-preview', JSON.stringify(draft)); } catch (_) {}
      });
      form.addEventListener('change', update);
      form.addEventListener('submit', event => {
        event.preventDefault();
        event.stopImmediatePropagation();
        if (!form.reportValidity()) return;
        form.querySelector('[data-preview-message]').textContent = form.elements.scenario.value === 'waitlist' ? form.dataset.waitlistSuccess : form.dataset.success;
        form.querySelector('[data-preview-summary]').textContent = form.elements.name.value + ' · ' + form.elements.email.value + ' · ' + form.elements.quantity.selectedOptions[0].text + ' · ' + total.textContent;
        fields.hidden = true;
        result.hidden = false;
        result.focus();
        try { sessionStorage.removeItem('to-event-preview'); } catch (_) {}
      });
      form.addEventListener('reset', () => {
        result.hidden = true;
        fields.hidden = false;
        try { sessionStorage.removeItem('to-event-preview'); } catch (_) {}
        queueMicrotask(update);
      });
      fields.disabled = false;
      update();
    }
    scope.querySelectorAll('[data-event-calendar]').forEach(button => {
      if (button.dataset.bound) return;
      button.dataset.bound = 'true';
      button.addEventListener('click', () => {
        const calendar = [
          'BEGIN:VCALENDAR','VERSION:2.0','PRODID:-//Technical Outdoor//Community//EN','CALSCALE:GREGORIAN','BEGIN:VEVENT',
          'UID:tor330-20261003@technicaloutdoor.com','DTSTAMP:20260930T050000Z','DTSTART:20261002T230000Z','DTEND:20261003T040000Z',
          'SUMMARY:Fresh Off TOR 330 - Running & Sharing Session',
          'LOCATION:Technical Outdoor Indonesia - Sentul Nirwana',
          'DESCRIPTION:13 km / +550 m. Trail run 06:00-09:00 WIB. Sharing 09:00-11:00 WIB. Calendar entry only - not a ticket or reservation.',
          'URL:https://samperin.com/event/fresh-off-tor-330-running-sharing-session','END:VEVENT','END:VCALENDAR',''
        ].map(line => line.match(/.{1,73}/g)?.join('\r\n ') || '').join('\r\n');
        const blob = URL.createObjectURL(new Blob([calendar],{type:'text/calendar;charset=utf-8'}));
        const link = document.createElement('a');
        link.href = blob; link.download = 'technical-outdoor-tor330-2026-10-03.ics'; link.click();
        setTimeout(() => URL.revokeObjectURL(blob), 1000);
      });
    });
  };
  initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
